<template>
  <div>
    <vue-ueditor-wrap
      :config="editorConfig"
      @ready="editorReady"
      @before-init="addCustomBtn"
      v-model="value"
      :editorId="editorId"
      :key="editorId"
    />
    <photo-gallery ref="photoGallery" :originalImg="true" @setImgPath="insertPicutre"></photo-gallery>
  </div>
</template>
<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import "../../../static/xiumi/xiumi-ue-v5.css";
import { VueCropper } from "vue-cropper";
import httpRequest from "../../utils/httpRequest";
import photoGallery from "./photo-gallery.vue";
export default {
  components: {
    VueUeditorWrap,
    VueCropper,
    photoGallery
  },
  model: {
    prop: "modelValue",
  },
  props: {
    modelValue: {
            type: String,
            default: '',
        },
     showXiumi:{
      type:Boolean,
      default:true
     } ,
     config:{
      type:Object,
      default:()=>{return {}}
     } 
  },
  emits: ['update:modelValue'],
  data() {
    return {
      myEditor: undefined,
      editorId:undefined,
      editorConfig: {
        autoHeightEnabled: true, //编译器不自动被内容撑高
        autoFloatEnabled: false,
        initialFrameHeight: 350, //初始容器高度
        initialFrameWith: 500,
        //serverUrl: "/api", //上传文件地址
        UEDITOR_HOME_URL: "/static/UEditor/", //UEditor资源文件的存放路径,
        catchRemoteImageEnable: true,
        uploadUrl:'/api/sysConfig/upload',
        imageMaxSize:1024*1024*500,
        imageFieldName:'file'
      },
    };
  },
  created() {
    Object.assign(this.editorConfig,this.config)
    this.editorId = Math.random().toString(16).slice(-8)
  },
  methods: {
    editorReady(editorInstance) {
      this.myEditor = editorInstance;
      editorInstance.customerUpload = (images, paths, callback) => {
        for (var i in paths) {
          this.getBase64(images[i], paths[i], callback);
        }
      };
    },
    //传入图片路径，返回base64
    getBase64(img, path, _callback) {
      function getBase64Image(img, width, height) {
        //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
        var canvas = document.createElement("canvas");
        canvas.width = width ? width : img.width;
        canvas.height = height ? height : img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataURL = canvas.toDataURL();
        return dataURL;
      }
      var image = new Image();
      image.crossOrigin = "";
      image.src = path;
      if (path) {
        image.onload = () => {
          var base64Data = getBase64Image(image);
          var blod = this.dataURItoBlob(base64Data);
          console.log("yct#debug", blod); //将base64传给done上传处理
          const formData = new FormData();
          formData.append("file", blod);
          httpRequest
            .upload("/api/sysConfig/upload", formData, {
              contentType: false,
              processData: false,
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            })
            .then((res) => {
              console.log(res);
              let newPath = res.data;
              if (location.href.indexOf("https:") >= 0) {
                newPath = newPath.replace("http:", "https:");
              }
              _callback.success(img, newPath);
            })
            .catch((e) => {
              console.log(e);
              _callback.error();
            });
        };
      }
    },
    /**
     * base64  to blob二进制
     */
    dataURItoBlob(dataURI) {
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0]; // mime类型
      var byteString = atob(dataURI.split(",")[1]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图

      for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], { type: mimeString });
    },
    insertPicutre(url){
      this.value=this.modelValue + `<img src='${url}' style='width:100%'/>`
    },
    addCustomBtn(id) {
      const that = this
      UE.registerUI("button", function (editor, uiName) {
        var btn = new UE.ui.Button({
          name: "素材库",
          title: "素材库",
          cssRules :'background-position: -380px 0;',
          editor: editor,
          onclick: function () {
            that.myEditor = editor
            that.$refs.photoGallery.open()
          },
        });
        return btn;
      });
      if(!this.showXiumi){//显示秀米
        return
      }
      UE.registerUI("dialog", function (editor, uiName) {
        var btn = new UE.ui.Button({
          name: "xiumi-connect",
          title: "秀米",
          onclick: function () {
            var dialog = new UE.ui.Dialog({
              iframeUrl: "/static/UEditor/xiumi-ue-dialog-v5.html",
              editor: editor,
              name: "xiumi-connect",
              title: "秀米图文消息助手",
              cssRules:
                "width: " +
                (window.innerWidth - 60) +
                "px;" +
                "height: " +
                (window.innerHeight - 60) +
                "px;",
            });
            dialog.render();
            dialog.open();
          },
        });
        return btn;
      });
    },
  },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(newValue) {
              //this.modelValue = newValue
                this.$emit('input', newValue)
                console.log(newValue);
                
                //this.$emit('update:modelValue', newValue)
            }
        }
    }
};
</script>
<style >
iframe{
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/plugin/my-editor-ueditor.vue